// © Microsoft Corporation. All rights reserved.

import { DesignSystem, isDarkMode, neutralForegroundHint } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../utils/enums";
import { getEmojiStylesByWidth } from "../../utils/emojiIcons";

export const ReactionPanelStyles = (config: DesignSystem) => ({
    reactionPanelContainer: {
        "touch-action": "none",
        display: "flex !important",
        "align-items": "center",

        "& div.emoji-icon": {
            ...getEmojiStylesByWidth(16),
            transition: "none"
        },

        "& > .cwt-icon": {
            "font-size": "16px",
            padding: "6px",
            margin: applyLocalizedProperty("-6px 6px -6px -6px", "-6px -6px -6px 6px", config.direction),

            "&.cwt-hide": {
                display: "none",
                "pointer-events": "none",
                "touch-events": "none"
            },

            '&:hover, &[data-has-over="true"]': {
                color: isDarkMode ? "#8D8D8D" : "#717272",
                "& .cwt-icon-label": {
                    color: isDarkMode ? "#8D8D8D" : "#717272"
                }
            },

            "& .cwt-icon-label": {
                "font-size": "13px",
                padding: "0 6px"
            }
        },

        "& .cwt-reply-btn.cwt-icon": {
            "& .cwt-icon-vector": {
                "margin-top": "2px"
            }
        },

        // 'RATING LABELS'
        "& > .cwt-icon .cwt-icon-label.cwt-red-reaction": {
            color: isDarkMode(config) ? "#FF948F" : "#E02F19"
        },
        "& > .cwt-icon .cwt-icon-label.cwt-yellow-reaction": {
            color: isDarkMode(config) ? "#FF9333" : "#BD5B00"
        },

        ["&." + enums.responsiveLevels.MobilePopup]: {
            "& > .cwt-icon:hover": {
                color: neutralForegroundHint
            }
        }
    }
});